import axios from 'axios'
import actions from '@/store/action-types'
import mutations from '@/store/mutation-types'

import { isEmptyObject } from '@/utils'

export default {
  state: {
    reportExist: true,
    nick: '',
    login: '',
    createdAt: 0,
    avatar: '',
    reports: {
      checkinDaysCount: 0,
      coins: 0,
      ptLevel: 0,
      goodAt: '睡前刷课',
      activeDaysCount: 0,
      totalMinutes: 0,
      recordSentencesCount: 0,
      speakingForce: 0,
      dialogAvgScore: 0,
      defeatRate: 0
    }
  },
  mutations: {
    [ mutations.update.REPORT_STATUS ] (state, payload) {
      if (!isEmptyObject(payload)) {
        for (let key in state.reports) {
          if (payload[key]) {
            state.reports[key] = payload[key]
          }
        }
        state.reportExist = true
      } else {
        state.reportExist = false
      }
    },
    [ mutations.update.USER_DATA ] (state, payload) {
      state.nick = payload.nick
      state.login = payload.login
      state.createdAt = payload.createdAt
      state.avatar = payload.avatar
    }
  },
  actions: {
    [ actions.get.USER_DATA ] ({ commit, rootState }) {
      return axios.get(`${rootState.API_BASE_URL}annual_reports/2017`, {
        params: rootState.urlParams
      }).then(({ data }) => {
        commit(mutations.update.USER_DATA, data)
        commit(mutations.update.REPORT_STATUS, data.reports)
      }).catch(error => {
        console.log(`${actions.get.USER_DATA}: ${error}`)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/data.js